// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Backbone from 'backbone';
import $ from 'jquery';

import CreateSourceModal from 'create-components/CreateSourceModal';
import runModal from 'ui-library/runModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

class CreateSourceHashView extends Backbone.View<Backbone.Model> {
  render(): this {
    function openModal(): void {
      runModal(CreateSourceModal, {});
    }

    $(document).on('click', '.js-create-new-project', (e) => {
      e.preventDefault();
      openModal();
    });

    ifCreateFromHash('#create/project', openModal);
    return this;
  }
}

export default CreateSourceHashView;
